import * as React from "react";
import * as main from "../../main.module.scss";
import * as smi from "./style.module.scss";
import data from "./data.json";
export const Smi = () => {
  const swiperVidsEl = React.useRef();
  React.useEffect(() => {
    if (swiperVidsEl.current) {
      Object.assign(swiperVidsEl.current, {
        slidesPerView: 1,
        spaceBetween: 5,
        navigation: {
          nextEl: '.swiper-btn-next',
          prevEl: '.swiper-btn-prev',
        },
        breakpoints: {
          767: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          991: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1100: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
      });
      swiperVidsEl.current.initialize();
    }
  }, []);
  return (
    <section className={smi.smi}>
      <div className="container">
        <div className={smi.head}>
          <div className={smi.wrap}>
            <h2 className={main.title}>СМИ о нас</h2>
            <p className={smi.sub}>Технологиями школы Advance уже в 2012 году заинтересовались федеральные каналы</p>
          </div>
          <div className={smi.desc}>
            <h3>В этом разделе мы собрали основные репортажи и статьи из экспертных изданий.</h3>
            <p>Читайте, смотрите — в интервью вы узнаете, что думают Александр Згода и эксперты Advance об образовании, обучении, бизнесе и развитии личности!</p>
          </div>
        </div>
        <swiper-wrapper style={{ position: "relative" }}>
          <swiper-container ref={swiperVidsEl} init="false">
            {data.map((elem, index) => (
              <swiper-slide key={index}>
                <div className={smi.img}>
                  <img src={elem.img} alt=""/>
                </div>
                <div className={smi.info}>
                  <h3>{elem.title}</h3>
                  <p>{elem.desc && elem.desc}</p>
                </div>
              </swiper-slide>
            ))}
          </swiper-container>
          <div className={smi.swiperButtons}>
            <button
              aria-label="swiper-btn-prev"
              className={`swiper-btn-prev ${smi.swiperBtnPrev}`}
            >
              <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="25" cy="25" r="24.6875" stroke="#7000E3" strokeWidth="0.625"/>
                <path d="M27.5 30L22.5 25L27.5 20" stroke="#7000E3" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <button
              aria-label="swiper-btn-next"
              className={`swiper-btn-next ${smi.swiperBtnNext}`}
            >
              <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="25" cy="25" r="24.6875" transform="matrix(-1 0 0 1 50 0)" stroke="#7000E3" strokeWidth="0.625"/>
                <path d="M22.5 30L27.5 25L22.5 20" stroke="#7000E3" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </swiper-wrapper>
      </div>
    </section>
  );
};
